import(/* webpackMode: "eager", webpackExports: ["LifeInsuranceWizardSection"] */ "/home/ext_sax01_pam/builds/AmxgYjbu2/0/sax/portal/src/app/esales/life/_sections/LifeInsuranceWizardSection/LifeInsuranceWizardSection.tsx");
